import { Box, Button, Typography } from "@mui/material";
import { SF } from "../../../utils/utils";
import { usePopupWindow } from "../../../hooks/usePopupWindow";
import { t } from "i18next";

interface ModalProps {
  onClose: () => void;
  onPopup?: () => void;
  openMakeDataSet: boolean;
}

export default function StatusModalHeader({ onClose, onPopup, openMakeDataSet }: ModalProps) {
  return (
    <>
      <Box
        sx={{
          height: 40,
          background: "var(--dk-surface-glass, rgba(255,255,255,0.6))",
          backdropFilter: "blur(12px)",
          borderBottom: "0.5px solid var(--dk-border, rgba(0,0,0,0.1))",
          display: "flex",
          alignItems: "center",
          px: "14px",
          gap: "8px",
        }}
      >
        <Typography
          sx={{
            flex: 1,
            textAlign: "center",
            fontSize: "13px",
            fontWeight: 500,
            color: "var(--dk-text-2, #3a3a3c)",
            mr: "52px",
            fontFamily: SF,
          }}
        >
          {openMakeDataSet ? t("NgList") : t("InspStatusInfo")}
        </Typography>
      </Box>
    </>
  );
}
